var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFormatHorizontal = function SvgFormatHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 15V9C4 7.89543 4.89543 7 6 7H19C20.1046 7 21 7.89543 21 9V15C21 16.1046 20.1046 17 19 17H6C4.89543 17 4 16.1046 4 15Z",
    stroke: "currentColor",
    strokeWidth: 1.2
  })));
};
export default SvgFormatHorizontal;